"use client";

import { useState } from "react";
import { STATUS_OPTIONEN, type KontoStatus } from "./status";
import { HaekchenSymbol, UrlaubSymbol } from "./symbole";
import { UntermenueFehler, useUntermenueOffenBeiFehler } from "./untermenue-fehler";

/**
 * Untermenü „Status setzen“ im Konto-Menü. Die Server-Actions kommen vom Aufrufer; wirft eine, steht ein
 * Satz im Untermenü (Fehlschlag, wiederholbar, nie ein Code) und das von Preline beim Klick geschlossene
 * Untermenü wird wieder geöffnet, damit die Meldung den Klick überlebt (r98, r105).
 */
const EINTRAG_VOLL =
  "w-full text-start flex items-center gap-x-2 py-2 px-3 rounded-lg text-sm text-dropdown-item-foreground hover:bg-dropdown-item-hover disabled:opacity-50 disabled:pointer-events-none focus:outline-hidden focus:bg-dropdown-item-focus";

export function StatusWahl({
  status,
  statusSetzen,
  statusLoeschen,
}: {
  status?: KontoStatus | null;
  statusSetzen?: (daten: FormData) => Promise<void>;
  statusLoeschen?: () => Promise<void>;
}) {
  const [fehler, setFehler] = useState(false);
  const ankerRef = useUntermenueOffenBeiFehler<HTMLDivElement>(fehler);

  async function setze(daten: FormData) {
    if (!statusSetzen) return;
    setFehler(false);
    try {
      await statusSetzen(daten);
    } catch {
      setFehler(true);
    }
  }

  async function loesche() {
    if (!statusLoeschen) return;
    setFehler(false);
    try {
      await statusLoeschen();
    } catch {
      setFehler(true);
    }
  }

  return (
    <>
      {/* Preline: ui-components/ui-components-sub-menus-selection/ui-components-cat-account-and-workspace-menus/account-menu-with-status-controls (Untermenü „Status“, Einträge mit Statuspunkt) */}
      {/* `.group`: Preline-HSDropdown sucht beim Klick auf ein menuitemradio per closest(".group") die Geschwister (Befund N1). */}
      <div className="group" ref={ankerRef}>
        {STATUS_OPTIONEN.map((o) => (
          <form key={o.zustand} action={setze}>
            <input type="hidden" name="state" value={o.zustand} />
            <button type="submit" role="menuitemradio" aria-checked={status?.zustand === o.zustand} className={EINTRAG_VOLL}>
              {o.punktMittel ? <span className={o.punktMittel} aria-hidden="true" /> : <UrlaubSymbol />}
              {o.label}
              {status?.zustand === o.zustand && <HaekchenSymbol />}
            </button>
          </form>
        ))}
      </div>
      {status && statusLoeschen && (
        <form action={loesche} className="pt-1 mt-1 border-t border-dropdown-divider">
          <button type="submit" className={EINTRAG_VOLL}>
            Status zurücksetzen
          </button>
        </form>
      )}
      {fehler && <UntermenueFehler>Der Status konnte nicht gespeichert werden. Bitte erneut versuchen.</UntermenueFehler>}
    </>
  );
}
